import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Course } from '../Models/course.model';
import { CartItemsCookieService } from '../Services/cartItemsCookie.service';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit{

  allCourses:Course[];
  scheduledCourses: Course[];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private cartItemsCookieService: CartItemsCookieService,
    private snotifyService: SnotifyService,
  ){}

  ngOnInit() {

    // scroll
    document.querySelector('#componentTop').scrollIntoView({ behavior: 'smooth', block: 'center' });

    this._route.data.subscribe(
      ({allCourses}) => {
      console.log('allcourses: ', allCourses);

      // sort by name
      allCourses.sort(function(a, b) {
        var start = a.courseOrder;
        var end = b.courseOrder; 
        if (start < end) {
          return -1;
        }
        if (start > end) {
          return 1;
        }

        return 0;
      });

      console.log('sorted', allCourses)
      this.allCourses = allCourses;

      this.scheduledCourses = this.allCourses.filter((c) => c.category == "scheduled");
    });
  }

  addItemToCart(course: Course){
    this.cartItemsCookieService.addItemIdToCartCookie(course.id);

    this.snotifyService.info(`Successfully added course: "${course.name}" to cart`, {position:SnotifyPosition.rightTop});

    this._router.navigateByUrl(`/cart-details`);
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts